import { render, staticRenderFns } from "./CardCarousel.vue?vue&type=template&id=444fc2d8&scoped=true&"
import script from "./CardCarousel.vue?vue&type=script&lang=js&"
export * from "./CardCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CardCarousel.vue?vue&type=style&index=0&id=444fc2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444fc2d8",
  null
  
)

export default component.exports